import React from 'react';

import { Formik, Form as FormikForm } from 'formik';

import { Button, Modal } from '@shared/components/bootstrap';
import { FormikFileFormGroup } from '@shared/components/fields/formik/formik_file_form_group';
import { FormikInputFormGroup } from '@shared/components/fields/formik/formik_input_form_group';

import { FormikTextAreaFormGroup } from '@admin/components/fields/formik/formik_text_area_form_group';
import type { Landing__Location__CardInput } from '@admin/schema';

export const LandingLocationCardModal: React.FC<{
  value?: Landing__Location__CardInput;
  onClose(): void;
  onSave(input: Landing__Location__CardInput): void;
}> = ({ value, onClose, onSave }) => {
  const onSubmit = (input: Landing__Location__CardInput) => {
    if (!input.title || !input.description || !input.alt) return;
    onSave(input);
  };

  return (
    <Modal onClose={onClose}>
      <Formik<Landing__Location__CardInput>
        initialValues={{
          title: value?.title ?? '',
          description: value?.description ?? '',
          alt: value?.alt ?? '',
        }}
        onSubmit={onSubmit}
      >
        <FormikForm>
          <Modal.Content>
            <Modal.Header>
              <Modal.Title>Card</Modal.Title>
              <Modal.Close close={onClose} />
            </Modal.Header>
            <Modal.Body>
              <FormikInputFormGroup id="title" name="title" label="Title:" />
              <FormikTextAreaFormGroup id="description" name="description" label="Description:" />
              <FormikInputFormGroup id="alt" name="alt" label="Alt:" />
              <FormikInputFormGroup id="cta" name="cta" label="CTA:" placeholder="Book Now" />
              <FormikFileFormGroup accept="image/*" id="photo" name="photo" label="Photo:" />
            </Modal.Body>
            <Modal.Footer>
              <Button type="submit" kind="primary">
                Save
              </Button>
            </Modal.Footer>
          </Modal.Content>
        </FormikForm>
      </Formik>
    </Modal>
  );
};
